// Selective FontAwesome icon imports — only icons used in icon-dictionary.config.ts
// fas (solid) icons
import {
  faAnglesLeft,
  faAnglesRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faArrowRotateRight,
  faArrowRightArrowLeft,
  faArrowTrendDown,
  faArrowTrendUp,
  faAward,
  faBan,
  faBarcode,
  faBars,
  faBell as faBellSolid,
  faBellConcierge,
  faBolt,
  faBomb,
  faBrain,
  faBriefcase,
  faBuildingColumns,
  faBullseye,
  faBus,
  faCalculator,
  faCamera,
  faCar,
  faCaretDown,
  faCashRegister,
  faChartArea,
  faChartColumn,
  faChartLine,
  faChartPie,
  faChartSimple,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faCircleCheck,
  faCircleDollarToSlot,
  faCircleExclamation,
  faCircleInfo,
  faCircleNodes,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faClipboardCheck,
  faClipboardList,
  faClipboardQuestion,
  faClock,
  faClockRotateLeft,
  faCloudBolt,
  faCode,
  faCodeCompare,
  faCoins,
  faCommentDollar,
  faComments,
  faCompassDrafting,
  faCreditCard as faCreditCardSolid,
  faCross,
  faCrosshairs,
  faCubes,
  faDesktop,
  faDiagramProject,
  faDollarSign,
  faDoorOpen,
  faDownload,
  faDroplet,
  faEllipsis,
  faEllipsisVertical,
  faEraser,
  faEye as faEyeSolid,
  faEyeSlash,
  faFax,
  faFile,
  faFileArrowUp,
  faFileCircleQuestion,
  faFileCircleXmark,
  faFileContract,
  faFileExport,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines as faFileLinesSolid,
  faFileShield,
  faFileSignature,
  faFolderTree,
  faGauge,
  faGear as faGearSolid,
  faGears,
  faGlasses,
  faGlobe,
  faGraduationCap,
  faHandHoldingDollar,
  faHashtag,
  faHeadset,
  faHeart,
  faHeartPulse,
  faHouse,
  faHouseChimney,
  faHouseChimneyUser,
  faHouseCircleCheck,
  faHouseCrack,
  faHouseLaptop,
  faIceCream,
  faIdBadge,
  faInbox,
  faKey,
  faKeyboard as faKeyboardSolid,
  faLandMineOn,
  faLandmark,
  faList,
  faListCheck,
  faLocationDot,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMessage as faMessageSolid,
  faMicrochip,
  faMobile,
  faMobileRetro,
  faMobileScreen,
  faMobileScreenButton,
  faMoneyBill,
  faMoneyBill1,
  faMoneyBill1Wave,
  faMoneyBillTransfer,
  faMoneyBillWave,
  faMoneyBills,
  faMoneyCheck,
  faMoneyCheckDollar,
  faNetworkWired,
  faNotEqual,
  faPaperPlane as faPaperPlaneSolid,
  faPaperclip,
  faPenRuler,
  faPenToSquare,
  faPeopleArrows,
  faPeopleGroup,
  faPeopleRoof,
  faPercent,
  faPersonWalkingArrowRight,
  faPhone,
  faPiggyBank,
  faPlay,
  faPlug,
  faPlugCircleCheck,
  faQrcode,
  faReceipt,
  faRectangleList as faRectangleListSolid,
  faRocket,
  faRotate,
  faRotateRight,
  faSackDollar,
  faScaleBalanced,
  faSchool,
  faScrewdriverWrench,
  faServer,
  faShareFromSquare,
  faShield,
  faShieldHalved,
  faShoePrints,
  faShop,
  faShopLock,
  faShopSlash,
  faSignature,
  faSliders,
  faFaceSmile,
  faSpinner,
  faSquareEnvelope,
  faStore,
  faStoreSlash,
  faSuitcase,
  faSyringe,
  faTableList,
  faTags,
  faThumbsDown,
  faThumbsUp as faThumbsUpSolid,
  faThumbtack,
  faThumbtackSlash,
  faTicket,
  faToggleOff,
  faToggleOn,
  faTrashCan,
  faTriangleExclamation,
  faTrophy,
  faTrowelBricks,
  faTv,
  faUnlock,
  faUser as faUserSolid,
  faUserGear,
  faUserLock,
  faUserPen,
  faUserShield,
  faUsers,
  faUsersBetweenLines,
  faUsersGear,
  faUsersRectangle,
  faUsersViewfinder,
  faWallet,
  faWeightScale,
  faWifi,
  faXmark,
  faArrowUpFromBracket,
  faFingerprint,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

// far (regular) icons
import {
  faAddressBook,
  faAddressCard,
  faBell,
  faClipboard,
  faClone,
  faComment,
  faCommentDots,
  faCopy,
  faCreditCard,
  faEye,
  faFileLines,
  faFolder,
  faFolderOpen,
  faHand,
  faIdCard,
  faKeyboard,
  faLightbulb,
  faMoneyBill1 as faMoneyBill1Regular,
  faPaperPlane,
  faRectangleList,
  faRectangleXmark,
  faSquare,
  faSquareCheck,
  faThumbsUp,
  faUser,
  faMessage,
} from '@fortawesome/free-regular-svg-icons';

export const FA_ICONS = [
  // fas
  faAnglesLeft,
  faAnglesRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faArrowRotateRight,
  faArrowRightArrowLeft,
  faArrowTrendDown,
  faArrowTrendUp,
  faAward,
  faBan,
  faBarcode,
  faBars,
  faBellSolid,
  faBellConcierge,
  faBolt,
  faBomb,
  faBrain,
  faBriefcase,
  faBuildingColumns,
  faBullseye,
  faBus,
  faCalculator,
  faCamera,
  faCar,
  faCaretDown,
  faCashRegister,
  faChartArea,
  faChartColumn,
  faChartLine,
  faChartPie,
  faChartSimple,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faCircleCheck,
  faCircleDollarToSlot,
  faCircleExclamation,
  faCircleInfo,
  faCircleNodes,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faClipboardCheck,
  faClipboardList,
  faClipboardQuestion,
  faClock,
  faClockRotateLeft,
  faCloudBolt,
  faCode,
  faCodeCompare,
  faCoins,
  faCommentDollar,
  faComments,
  faCompassDrafting,
  faCreditCardSolid,
  faCross,
  faCrosshairs,
  faCubes,
  faDesktop,
  faDiagramProject,
  faDollarSign,
  faDoorOpen,
  faDownload,
  faDroplet,
  faEllipsis,
  faEllipsisVertical,
  faEraser,
  faEyeSolid,
  faEyeSlash,
  faFax,
  faFile,
  faFileArrowUp,
  faFileCircleQuestion,
  faFileCircleXmark,
  faFileContract,
  faFileExport,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLinesSolid,
  faFileShield,
  faFileSignature,
  faFolderTree,
  faGauge,
  faGearSolid,
  faGears,
  faGlasses,
  faGlobe,
  faGraduationCap,
  faHandHoldingDollar,
  faHashtag,
  faHeadset,
  faHeart,
  faHeartPulse,
  faHouse,
  faHouseChimney,
  faHouseChimneyUser,
  faHouseCircleCheck,
  faHouseCrack,
  faHouseLaptop,
  faIceCream,
  faIdBadge,
  faInbox,
  faKey,
  faKeyboardSolid,
  faLandMineOn,
  faLandmark,
  faList,
  faListCheck,
  faLocationDot,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMessageSolid,
  faMicrochip,
  faMobile,
  faMobileRetro,
  faMobileScreen,
  faMobileScreenButton,
  faMoneyBill,
  faMoneyBill1,
  faMoneyBill1Wave,
  faMoneyBillTransfer,
  faMoneyBillWave,
  faMoneyBills,
  faMoneyCheck,
  faMoneyCheckDollar,
  faNetworkWired,
  faNotEqual,
  faPaperPlaneSolid,
  faPaperclip,
  faPenRuler,
  faPenToSquare,
  faPeopleArrows,
  faPeopleGroup,
  faPeopleRoof,
  faPercent,
  faPersonWalkingArrowRight,
  faPhone,
  faPiggyBank,
  faPlay,
  faPlug,
  faPlugCircleCheck,
  faQrcode,
  faReceipt,
  faRectangleListSolid,
  faRocket,
  faRotate,
  faRotateRight,
  faSackDollar,
  faScaleBalanced,
  faSchool,
  faScrewdriverWrench,
  faServer,
  faShareFromSquare,
  faShield,
  faShieldHalved,
  faShoePrints,
  faShop,
  faShopLock,
  faShopSlash,
  faSignature,
  faSliders,
  faFaceSmile,
  faSpinner,
  faSquareEnvelope,
  faStore,
  faStoreSlash,
  faSuitcase,
  faSyringe,
  faTableList,
  faTags,
  faThumbsDown,
  faThumbsUpSolid,
  faThumbtack,
  faThumbtackSlash,
  faTicket,
  faToggleOff,
  faToggleOn,
  faTrashCan,
  faTriangleExclamation,
  faTrophy,
  faTrowelBricks,
  faTv,
  faUnlock,
  faUserSolid,
  faUserGear,
  faUserLock,
  faUserPen,
  faUserShield,
  faUsers,
  faUsersBetweenLines,
  faUsersGear,
  faUsersRectangle,
  faUsersViewfinder,
  faWallet,
  faWeightScale,
  faWifi,
  faXmark,
  faFingerprint,
  faEnvelope,
  // far
  faAddressBook,
  faAddressCard,
  faBell,
  faClipboard,
  faClone,
  faComment,
  faCommentDots,
  faCopy,
  faCreditCard,
  faEye,
  faFileLines,
  faFolder,
  faFolderOpen,
  faHand,
  faIdCard,
  faKeyboard,
  faLightbulb,
  faMoneyBill1Regular,
  faPaperPlane,
  faRectangleList,
  faRectangleXmark,
  faSquare,
  faSquareCheck,
  faThumbsUp,
  faUser,
  faMessage,
  faArrowUpFromBracket,
];
